import React from "react";
import { useAccount } from "../../../hooks/client";
import styled, { css } from "styled-components";
import { IncreaseMyRepayments } from "./increaseMyRepayments";
import { ManageMyRepayments } from "./manageMyRepayments";
import { ManageMyArrears } from "./manageMyArrears";

const ManageRepaymentOptionsWrapper = styled.div(({ theme }) => css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-left: -12px;
  margin-bottom: -12px;

  @media only screen and (min-width: ${theme.breakpoints.M}) {
    justify-content: start;
  }

  & > * {
    margin-left: 12px;
    margin-bottom: 12px;
  }
`);

export const ManageRepaymentOptions = ({ accountId }) => {
  const { arrears } = useAccount(accountId) || {};

  return (
    <ManageRepaymentOptionsWrapper>
      {arrears === "" ? (
        <>
          <IncreaseMyRepayments accountId={accountId} />
          <ManageMyRepayments accountId={accountId} />
        </>
      ) : (
        <ManageMyArrears accountId={accountId} />
      )}
    </ManageRepaymentOptionsWrapper>
  );
};
